import { render, staticRenderFns } from "./MultichatSmsPromoPanel.vue?vue&type=template&id=bada40ba&scoped=true"
import script from "./MultichatSmsPromoPanel.vue?vue&type=script&lang=ts"
export * from "./MultichatSmsPromoPanel.vue?vue&type=script&lang=ts"
import style0 from "./MultichatSmsPromoPanel.vue?vue&type=style&index=0&id=bada40ba&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bada40ba",
  null
  
)

export default component.exports